var React = require('react');

function CInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"C icon"),React.createElement("path",{"d":"M17.023 9.216s-.386-3.293-3.955-3.385c-3.57-.091-5.402 2.47-5.402 6.13 0 3.66 2.026 6.588 5.498 6.588 3.473 0 3.86-3.66 3.86-3.66l6.656.366s.391 3.306-2.394 5.828C18.5 23.605 15.082 24.017 12.694 24c-2.388-.018-5.698.034-8.9-2.969C.595 18.03.05 15.113.05 12.248c0-2.866.607-6.661 4.414-9.54C7.05.754 9.673.033 12.296.033 23.246.032 23.98 9.28 23.98 9.28z","key":1})]);
}

CInline.defaultProps = {"role":"img","viewBox":"0 0 24 24"};

module.exports = CInline;

CInline.default = CInline;
